import Vue from "vue"
import Vuex from "vuex"

import systemInfo from "./modules/systemInfo"
import auth from "./modules/auth"
import ads from "./modules/ads"
import channels from "./modules/channels"
import programs from "./modules/programs"
import overview from "./modules/overview"
import cookie from "./modules/cookie"

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        systemInfo,
        auth,
        ads,
        channels,
        programs,
        overview,
        cookie,
    },
})
